package ar.corzo.health_tracker.types.state

enum class State{
    Success, Loading, Error;
    companion object{
        fun isSuccess(success: Boolean) = if(success) Success else Error
        fun <VALUE> VALUE?.toState() = if(this==null) Error else Success
    }
}